import React from 'react';
import { Box, Typography } from '@applyboard/ui-components';
import { HeaderConstants } from "../Constants";
import { CEF_Clock, CEF_Star_List } from "../Images";
var DurationGraphics = function DurationGraphics(props) {
  var _props$timeLeft = props.timeLeft,
    timeLeft = _props$timeLeft === void 0 ? HeaderConstants.FiveMins : _props$timeLeft,
    _props$questionsLeft = props.questionsLeft,
    questionsLeft = _props$questionsLeft === void 0 ? HeaderConstants.SixToEightQuestions : _props$questionsLeft;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CEF_Clock, null)), /*#__PURE__*/React.createElement(Box, {
    m: "1px 0 0 10px"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, timeLeft))), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    ml: "35px",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CEF_Star_List, null)), /*#__PURE__*/React.createElement(Box, {
    m: "1px 0 0 10px"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, questionsLeft))));
};
export default DurationGraphics;